module.exports = __webpack_public_path__ + "img/icon-book-white.50d31612.png";